import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksVendorDetailsSection', {
    placeholder: 'Enter your message to the vendor',
    title: 'Vendor message',
});
